import { UIActionType, UIAction } from '../../actions/uiActions';

const drawerReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_DRAWER:
      return !state;
    default:
      return state;
  }
};

export default drawerReducer;
